//Agent Login and Logout
export const AGENT_LOGIN_START = 'AGENT_LOGIN_START';
export const AGENT_LOGIN_SUCCESS = 'AGENT_LOGIN_SUCCESS';
export const AGENT_LOGIN_FAIL = 'AGENT_LOGIN_FAIL';
export const AGENT_LOGIN_WAIT = 'AGENT_LOGIN_WAIT';
export const AGENT_LOGOUT_START = 'AGENT_LOGOUT_START';
export const AGENT_LOGOUT_SUCCESS = 'AGENT_LOGOUT_SUCCESS';
export const AGENT_LOGOUT_FAIL = 'AGENT_LOGOUT_FAIL';
export const AGENT_LOGOUT_WAIT = 'AGENT_LOGOUT_WAIT';
export const AGENT_LOGOUT = 'AGENT_LOGOUT';

//ValiDate Agent
export const AGENT_VALIDATE_START = 'AGENT_VALIDATE_START';
export const AGENT_VALIDATE_FAIL = 'AGENT_VALIDATE_FAIL';
export const AGENT_VALIDATE_SUCCESS = 'AGENT_VALIDATE_SUCCESS';

//Agent Password Rest

export const AGENT_PASSWORD_Start = 'AGENT_PASSWORD_Start';
export const AGENT_PASSWORD_FAIL = 'AGENT_PASSWORD_FAIL';
export const AGENT_PASSWORD_SUCCESS = 'AGENT_PASSWORD_SUCCESS';

//Layout
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

//Agent State
export const AGENT_STATE_UPDATE = 'AGENT_STATE_UPDATE';

//Agent Configuration
export const AGENT_CONFIG_START = 'AGENT_CONFIG_START';
export const AGENT_CONFIG_SUCCESS = 'AGENT_CONFIG_SUCCESS';
export const AGENT_CONFIG_FAIL = 'AGENT_CONFIG_FAIL';

//Agent mode
export const AGENT_MODE_CHANGE_START = 'AGENT_MODE_CHANGE_START';
export const AGENT_MODE_CHANGE_SUCCESS = 'AGENT_MODE_CHANGE_SUCCESS';
export const AGENT_MODE_CHANGE_FAIL = 'AGENT_MODE_CHANGE_FAIL';
export const AGENT_MODE_UPDATE = 'AGENT_MODE_UPDATE';

//call queue info
export const QUEUE_CALLS_START = 'QUEUE_CALLS_START';
export const QUEUE_CALLS_FAIL = 'QUEUE_CALLS_FAIL';
export const QUEUE_CALLS_SUCCESS = 'QUEUE_CALLS_SUCCESS';

//AGENT_NOTIFICATION Data
export const AGENT_NOTIFICATION_START = 'AGENT_NOTIFICATION_START';
export const AGENT_NOTIFICATION_SUCCESS = 'AGENT_NOTIFICATION_SUCCESS';
export const AGENT_NOTIFICATION_FAIL = 'AGENT_NOTIFICATION_FAIL';

//Agent today call info
export const CALL_INFO_START = 'CALL_INFO_START';
export const CALL_INFO_SUCCESS = 'CALL_INFO_SUCCESS';
export const CALL_INFO_FAIL = 'CALL_INFO_FAIL';
export const CALL_INFO_UPDATE = 'CALL_INFO_UPDATE';

//lead comment history
export const LEAD_COMMENT_START = 'LEAD_COMMENT_START';
export const LEAD_COMMENT_SUCCESS = 'LEAD_COMMENT_SUCCESS';
export const LEAD_COMMENT_FAIL = 'LEAD_COMMENT_FAIL';

//Agent Lead Bucket Data
export const LEAD_DATA_START = 'LEAD_DATA_START';
export const LEAD_DATA_SUCCESS = 'LEAD_DATA_SUCCESS';
export const LEAD_DATA_FAIL = 'LEAD_DATA_FAIL';
export const LEAD_DATA_UPDATE = 'LEAD_DATA_UPDATE';

//Agent Break
export const BREAK_REASON_START = 'BREAK_REASON_START';
export const BREAK_REASON_SUCCESS = 'BREAK_REASON_SUCCESS';
export const BREAK_REASON_FAIL = 'BREAK_REASON_FAIL';

export const AGENT_BREAK_START = 'AGENT_BREAK_START';
export const AGENT_BREAK_SUCCESS = 'AGENT_BREAK_SUCCESS';
export const AGENT_BREAK_FAIL = 'AGENT_BREAK_FAIL';

// Dialing a number
export const AGENT_DIAL_START = 'AGENT_DIAL_START';
export const AGENT_DIAL_SUCCESS = 'AGENT_DIAL_SUCCESS';
export const AGENT_DIAL_FAIL = 'AGENT_DIAL_FAIL';

//Dialing a Unique ID
export const AGENT_DIAL_UNIQUE_ID_START = 'AGENT_DIAL_UNIQUE_ID_START';
export const AGENT_DIAL_UNIQUE_ID_SUCCESS = 'AGENT_DIAL_UNIQUE_ID_SUCCESS';
export const AGENT_DIAL_UNIQUE_ID_FAIL = 'AGENT_DIAL_UNIQUE_ID_FAIL';

// Disconnect a number
export const AGENT_DISCONNECT_START = 'AGENT_DISCONNECT_START';
export const AGENT_DISCONNECT_SUCCESS = 'AGENT_DISCONNECT_SUCCESS';
export const AGENT_DISCONNECT_FAIL = 'AGENT_DISCONNECT_FAIL';
export const AGENT_DISCONNECT_RESET = 'AGENT_DISCONNECT_RESET';

// Disconnect Tel number
export const AGENT_TEL_DISCONNECT_START = 'AGENT_TEL_DISCONNECT_START';
export const AGENT_TEL_DISCONNECT_SUCCESS = 'AGENT_TEL_DISCONNECT_SUCCESS';
export const AGENT_TEL_DISCONNECT_FAIL = 'AGENT_TEL_DISCONNECT_FAIL';


//Agent Hold
export const AGENT_HOLD_START = 'AGENT_HOLD_START';
export const AGENT_HOLD_SUCCESS = 'AGENT_HOLD_SUCCESS';
export const AGENT_HOLD_FAIL = 'AGENT_HOLD_FAIL';

//Agent Notes
export const AGENT_NOTES_START = 'AGENT_NOTES_START';
export const AGENT_NOTES_SUCCESS = 'AGENT_NOTES_SUCCESS';
export const AGENT_NOTES_FAIL = 'AGENT_NOTES_FAIL';

//Agent Transfer
export const GET_TRANSFERABLE_AGENTS_START = 'GET_TRANSFERABLE_AGENTS_START';
export const GET_TRANSFERABLE_AGENTS_SUCCESS = 'GET_TRANSFERABLE_AGENTS_SUCCESS';
export const GET_TRANSFERABLE_AGENTS_FAIL = 'GET_TRANSFERABLE_AGENTS_FAIL';

export const GET_TRANSFERABLE_CAMPAIGN_START = 'GET_TRANSFERABLE_CAMPAIGN_START';
export const GET_TRANSFERABLE_CAMPAIGN_SUCCESS = 'GET_TRANSFERABLE_CAMPAIGN_SUCCESS';
export const GET_TRANSFERABLE_CAMPAIGN_FAIL = 'GET_TRANSFERABLE_CAMPAIGN_FAIL';

export const GET_TRANSFERABLE_SKILL_START = 'GET_TRANSFERABLE_SKILL_START';
export const GET_TRANSFERABLE_SKILL_SUCCESS = 'GET_TRANSFERABLE_SKILL_SUCCESS';
export const GET_TRANSFERABLE_SKILL_FAIL = 'GET_TRANSFERABLE_SKILL_FAIL';

export const GET_TRANSFERABLE_EXTENSION_START = 'GET_TRANSFERABLE_EXTENSION_START';
export const GET_TRANSFERABLE_EXTENSION_SUCCESS = 'GET_TRANSFERABLE_EXTENSION_SUCCESS';
export const GET_TRANSFERABLE_EXTENSION_FAIL = 'GET_TRANSFERABLE_EXTENSION_FAIL';

export const TRANSFER_AGENT_START = 'TRANSFER_AGENT_START';
export const TRANSFER_AGENT_SUCCESS = 'TRANSFER_AGENT_SUCCESS';
export const TRANSFER_AGENT_FAIL = 'TRANSFER_AGENT_FAIL';

export const TRANSFER_CAMPAIGN_START = 'TRANSFER_CAMPAIGN_START';
export const TRANSFER_CAMPAIGN_SUCCESS = 'TRANSFER_CAMPAIGN_SUCCESS';
export const TRANSFER_CAMPAIGN_FAIL = 'TRANSFER_CAMPAIGN_FAIL';

export const TRANSFER_EXTENSION_START = 'TRANSFER_EXTENSION_START';
export const TRANSFER_EXTENSION_SUCCESS = 'TRANSFER_EXTENSION_SUCCESS';
export const TRANSFER_EXTENSION_FAIL = 'TRANSFER_EXTENSION_FAIL';

export const TRANSFER_UNSET_SUCCESS = 'TRANSFER_UNSET_SUCCESS';

//Customer CRM Handling
export const CREATE_CUSTOMER_START = 'CREATE_CUSTOMER_START';
export const CREATE_CUSTOMER_FAIL = 'CREATE_CUSTOMER_FAIL';
export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';

export const GET_CUSTOMER_DETAILS_START = 'GET_CUSTOMER_DETAILS_START';
export const GET_CUSTOMER_DETAILS_FAIL = 'GET_CUSTOMER_DETAILS_FAIL';
export const GET_CUSTOMER_DETAILS_SUCCESS = 'GET_CUSTOMER_DETAILS_SUCCESS';
export const RESET_CUSTOMER_DETAILS = 'RESET_CUSTOMER_DETAILS';

export const CUSTOMER_DETAILS_START = 'CUSTOMER_DETAILS_START';
export const CUSTOMER_DETAILS_FAIL = 'CUSTOMER_DETAILS_FAIL';
export const CUSTOMER_DETAILS_SUCCESS = 'CUSTOMER_DETAILS_SUCCESS';

//Call Conference
export const LEAVE_CONF_START = 'LEAVE_CONF_START';
export const LEAVE_CONF_FAIL = 'LEAVE_CONF_FAIL';
export const LEAVE_CONF_SUCCESS = 'LEAVE_CONF_SUCCESS';

export const JOIN_CONF_START = 'JOIN_CONF_START';
export const JOIN_CONF_FAIL = 'JOIN_CONF_FAIL';
export const JOIN_CONF_SUCCESS = 'JOIN_CONF_SUCCESS';

export const GET_CONF_DETAIL_START = 'GET_CONF_DETAIL_START';
export const GET_CONF_DETAIL_FAIL = 'GET_CONF_DETAIL_FAIL';
export const GET_CONF_DETAIL_SUCCESS = 'GET_CONF_DETAIL_SUCCESS';

export const JOIN_CONF_AGENT_START = 'JOIN_CONF_AGENT_START';
export const JOIN_CONF_AGENT_FAIL = 'JOIN_CONF_AGENT_FAIL';
export const JOIN_CONF_AGENT_SUCCESS = 'JOIN_CONF_AGENT_SUCCESS';

export const CONF_DISCONNECT_START = 'CONF_DISCONNECT_START';
export const CONF_DISCONNECT_FAIL = 'CONF_DISCONNECT_FAIL';
export const CONF_DISCONNECT_SUCCESS = 'CONF_DISCONNECT_SUCCESS';

export const CONF_DIAL_START = 'CONF_DIAL_START';
export const CONF_DIAL_FAIL = 'CONF_DIAL_FAIL';
export const CONF_DIAL_SUCCESS = 'CONF_DIAL_SUCCESS';

export const SEND_DTMF_START = 'SEND_DTMF_START';
export const SEND_DTMF_FAIL = 'SEND_DTMF_FAIL';
export const SEND_DTMF_SUCCESS = 'SEND_DTMF_SUCCESS';

export const BACK_TO_AGENT_START = 'BACK_TO_AGENT_START';
export const BACK_TO_AGENT_FAIL = 'BACK_TO_AGENT_FAIL';
export const BACK_TO_AGENT_SUCCESS = 'BACK_TO_AGENT_SUCCESS';

export const CONF_MUTE_START = 'CONF_MUTE_START';
export const CONF_MUTE_FAIL = 'CONF_MUTE_FAIL';
export const CONF_MUTE_SUCCESS = 'CONF_MUTE_SUCCESS';

// Call Disposition
export const GET_DISPOSITION_START = 'GET_DISPOSITION_START';
export const GET_DISPOSITION_FAIL = 'GET_DISPOSITION_FAIL';
export const GET_DISPOSITION_SUCCESS = 'GET_DISPOSITION_SUCCESS';

export const SET_DISPOSITION_START = 'SET_DISPOSITION_START';
export const SET_DISPOSITION_FAIL = 'SET_DISPOSITION_FAIL';
export const SET_DISPOSITION_SUCCESS = 'SET_DISPOSITION_SUCCESS';
export const SET_DISPOSITION_RESET = 'SET_DISPOSITION_RESET';

// Online Agent Name
//Agent Configuration
export const ONLINE_AGENT_START = 'ONLINE_AGENT_START';
export const ONLINE_AGENT_SUCCESS = 'ONLINE_AGENT_SUCCESS';
export const ONLINE_AGENT_FAIL = 'ONLINE_AGENT_FAIL';

//Manual Lead
export const MANUAL_LEAD_START = 'MANUAL_LEAD_START';
export const MANUAL_LEAD_SUCCESS = 'MANUAL_LEAD_SUCCESS';
export const MANUAL_LEAD_FAIL = 'MANUAL_LEAD_FAIL';


// Call History
export const CALL_HISTORY_START = 'CALL_HISTROY_START';
export const CALL_HISTORY_SUCCESS = 'CALL_HISTORY_SUCCESS';
export const CALL_HISTORY_FAIL = 'CALL_HISTORY_FAIL';
export const CALL_HISTORY_UPDATE = 'CALL_HISTORY_UPDATE';

// Call Parking
export const CALL_STATUS_START = 'CALL_STATUS_START';
export const CALL_STATUS_FAIL = 'CALL_STATUS_FAIL';
export const CALL_STATUS_SUCCESS = 'CALL_STATUS_SUCCESS';

export const CALL_PARK_START = 'CALL_PARK_START';
export const CALL_PARK_FAIL = 'CALL_PARK_FAIL';
export const CALL_PARK_SUCCESS= 'CALL_PARK_SUCCESS';

export const CALL_UNPARK_START = 'CALL_UNPARK_START';
export const CALL_UNPARK_FAIL = 'CALL_UNPARK_FAIL';
export const CALL_UNPARK_SUCCESS = 'CALL_UNPARK_SUCCESS';


// Call History Agent
export const CALL_AGENT_HISTORY_START = 'CALL_AGENT_HISTROY_START';
export const CALL_AGENT_HISTORY_SUCCESS = 'CALL_AGENT_HISTORY_SUCCESS';
export const CALL_AGENT_HISTORY_FAIL = 'CALL_AGENT_HISTORY_FAIL';
